module.exports = __webpack_public_path__ + "img/6.png.96481dd9.webp";